import { UseMutationOptions, useMutation } from 'react-query'
import { useCreateSource } from './useCreateSource'
import { Importer } from 'screens/BrandKits/components/BrandVoice/ContentSourcePicker/ContentSourcePicker'
import { absurd, PlainText, Website } from 'types'
import { isURL } from 'validator'

interface Data {
  source: Website | PlainText
}

interface Variables {
  content: string
  importer: Importer
  signal?: AbortSignal
}

export const useCreateSourceFromImport = (
  options?: Omit<UseMutationOptions<Data, unknown, Variables>, 'mutationFn'>,
) => {
  const { mutateAsync } = useCreateSource()
  return useMutation<Data, Error, Variables>(async ({ content, importer, signal }) => {
    switch (importer) {
      case Importer.SelectDoc:
      case Importer.UploadFiles:
      case Importer.PasteWebsiteText:
      case Importer.AddText: {
        return mutateAsync({ text: content, type: 'PlainText', signal }) as Promise<{ source: PlainText }>
      }
      case Importer.ScanWebsite: {
        let url = content
        if (
          !isURL(url, { require_tld: true, require_protocol: true }) &&
          isURL(`https://${url}`, { require_tld: true, require_protocol: true })
        ) {
          // if we can turn `sample` into a valid URL by prepending `https://`, do so
          url = `https://${url}`
        }

        return mutateAsync({ url, type: 'Website', signal }) as Promise<{ source: Website }>
      }
      default:
        absurd(importer)
        throw new Error('unrecognised importer')
    }
  }, options)
}
